import { render, staticRenderFns } from "./PRO_BasicSummary.vue?vue&type=template&id=e6c0beb8&scoped=true&"
import script from "./PRO_BasicSummary.vue?vue&type=script&lang=js&"
export * from "./PRO_BasicSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c0beb8",
  null
  
)

export default component.exports